export const SET_APPS_HEADER = 'SET_APPS_HEADER';
export const CLEAR_APPS_HEADER = 'CLEAR_APPS_HEADER';
export const SET_ENTITIES_BADGE = 'SET_ENTITIES_BADGE';
export const HIDE_HOME_MENU_ITEMS = 'HIDE_HOME_MENU_ITEMS';
